// extracted by mini-css-extract-plugin
export default {"title":"ContactHistory_title__L5duN","order":"ContactHistory_order__IauLM","date":"ContactHistory_date__Qpam4","state":"ContactHistory_state__xcFOm"};